import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, vShow as _vShow, Transition as _Transition, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a70e2a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "numberRectangle mr-10",
  style: {"background":"rgb(201, 225, 255)"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("获取客户流水发票")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("未匹配客户流水")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("计算流水本位币")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("计算发票本位币")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("导入")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("重置多选匹配")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("颜色含义")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("流水表格颜色")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean verifiedRow" }, "已核销", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean partVerifiedRow" }, "部分核销", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean yellowRow" }, "未核销，已匹配", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean toBeVerifiedRow" }, "未核销", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("发票表格颜色")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean verifiedRow" }, "已核销", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean greenInvRow" }, "历史导入数据", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean garyInvRow" }, "已删除", -1))
const _hoisted_18 = { class: "customerGroup" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "flowQuantityDot" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "flowGroup" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mb-10" }, "如果是否客户流水发票选择是，则搜索的是之前匹配的客户流水发票", -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode("导出订单")
const _hoisted_29 = { style: {"text-align":"center"} }
const _hoisted_30 = { class: "dialog-footer" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("获取")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("清空勾选")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("确定")

import { ref, reactive, onBeforeMount, computed, onMounted, onActivated, watch } from 'vue'
import Api from '@/http/modules/index'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import FlowOrderCompare from './ViewsComponents/financialReceivable/FlowOrderCompare.vue'
import SingleFlows from './ViewsComponents/payAccount/Unmatched.vue'
import { formatNumber, getNumber, formatTime, exportHandle } from '@/utils/index'
import { ElMessage, ElMessageBox } from 'element-plus'
import dayjs from 'dayjs'
import { categorysFunc } from '@/views/typeMapping/OrderMap'
import { default as vElTableInfiniteScroll } from "el-table-infinite-scroll";
import tbMix, { orgCfig } from '@/global_mixin/tableMixin'

export default /*#__PURE__*/_defineComponent({
  props: {
  salesmanParams: {
    type: Object,
    default: {},
    required: false,
  }
},
  setup(__props) {

const props = __props

const {
  // 客户列表与流水(左)
  'POST/sale/customers': fetchCustomersApi,
  // 发票查询
  // 'POST/verification/translation/all_invoice': fetchInvoiceList,
  // 新发票查询
  'POST/verification/liquidate/invoices': fetchInvoiceList,
  // 获取组列表
  'GET/verification/accounts/groups': verificationAccountsGroupsApi,
  // 订单查询
  'POST/order/list': orderListApi,
  // 订单类别下拉框
  'GET/order_categorys/list': order_categorysListApi,
  // 开票公司列表
  'GET/order/invoice_companies': invoice_companiesApi,
  // 未匹配客户流水
  'POST/verification/liquidate/not_match_flow': not_match_flowApi,
  // 根据客户ID获取流水
  'GET/sale/customer/flows': customerFlowsApi,
  // 计算本位币（发票）
  'POST/order/receivable/compute_invoice_rate': compute_invoice_rateApi,
  // 计算本位币（流水）
  'POST/order/receivable/compute_flow_rate': compute_flow_rateApi,
  // 根据发票号/订单号查询
  'POST/verification/liquidate/nos': nosApi,
  // 根据订单号导出
  'POST/verification/liquidate/nos/export': exportNosApi,
  // 获取流水绑定的订单
  'POST/financial_flows/orders_of_flow_product': orders_of_flow_productApi,
} = Api
let {currencyOption} = PaymentModuleUtils


const flowsListType = ref<boolean>(false)
const singleFlowsEle = ref()
let gruopList: any = ref([])

let orderCategorysOption: any = ref([])
let companyInvice: any = ref([])
onBeforeMount(() => {
  verificationAccountsGroupsApi().then((rep) => {
    gruopList.value = rep.map((_group: string) => {
      return { label: _group, id: _group, }
    })
  })

  // 订单类别下拉框 
  order_categorysListApi().then((rep: any) => {
    orderCategorysOption.value = rep.map((e: any) => ({label: categorysFunc()[e.category] + '-' + e.name, categoryId: e.id}))
  })

  // 订单发票主体 
  invoice_companiesApi().then((rep: any) => {
    companyInvice.value = rep.map((com: string) => {
      return { label: com, id: com }
    }).concat([{label: '空白', id: '空白'}])
  })
})

// 客户流水分组列表
let cutTable = ref()
let cusFlowsSeleRows: any = ref([])
const {
  MI_tableData: custData, fetchData: fetchCustomer, page: custPage, size: custSize, MI_total: custTotal, MI_pageChange: custPageChange,
  MI_sizeChange: custSizeChange, MI_identify: custIdentify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchCustomersApi)

watch(custIdentify, async (newIdentify, oldIdentify) => {
  // cutTable.value.clearSelection()
  // cusFlowsSeleRows.value = []
})

const searchCustomerHandle = (params: any) => {
  
  fetchCustomer({
    ...params,
    collectionFrom: params.dates ? params.dates[0] : '',
    collectionto: params.dates ? params.dates[1] : '',
    ...props.salesmanParams
  })
}

const custConfig = ref([
  {
    label: '流水ID',
    value: '',
    upKey: 'flowId',
    props: { clearable: true },
  },
  {
    label: '客户名称',
    value: '',
    upKey: 'customer',
    props: { clearable: true },
  },
  {
    label: '客户ID',
    value: '',
    upKey: 'customerId',
    props: { clearable: true },
  },
  {
    label: '收付方名称',
    value: '',
    upKey: 'costTo',
    props: { clearable: true },
  },
  {
    type: 'NUMBER',
    label: '收款金额',
    value: undefined,
    upKey: 'receiptAmount',
    props: { clearable: true },
  },
  {
    type: "TIME",
    label: "流水日期范围",
    value: [],
    upKey: 'dates',
    // upProps: {startKey: 'collectionFrom', endKey: 'collectionto'},
    props: {
      type: 'daterange',
      'value-format': 'YYYY-MM-DD'
    }
  },
])

const loadFlowRow = (row: any, treeNode: any, resolve: any) => {
  customerFlowsApi({customerId: row.customerId}).then((rep) => {
    row.flows = rep
    resolve(rep)
  })
}

const seleCustomerRow = (selection: any, row: any) => {
  // 判断为勾选或者取消勾选
  const isSelect = selection.some((e: {id: number}) => e.id === row.id)
  // 包含流水
  if(row.hasChildren === true){
    row.flows.map((_flow: any) => {
      // 判断是否已添加
      let index = cusFlowsSeleRows.value.findIndex((item: any) => item.id === _flow.id)
      // 全选添加所有流水
      if(isSelect && index === -1){
        cusFlowsSeleRows.value.push(_flow)
      }
      // 取消全选,删除所有流水
      if(!isSelect && index !== -1){
        cusFlowsSeleRows.value.splice(index, 1)
      }
      cutTable.value.toggleRowSelection(_flow, !!isSelect)
    })
    return
  }
  // 直接选择流水
  let index = cusFlowsSeleRows.value.findIndex((item: any) => item.id === row.id)
  if(isSelect){
    cusFlowsSeleRows.value.push(row)
  } else {
    cusFlowsSeleRows.value.splice(index, 1)
  }
}
let isFullSeleCus = false
const seleFullCustomer = (selection: any) => {
  // true为全选
  isFullSeleCus = !isFullSeleCus

  // 统一取消全选
  cusFlowsSeleRows.value = []
  cutTable.value.clearSelection()
  if(!isFullSeleCus) return;

  // 全选
  selection.map(row => {
    if(!row.flows) return;
    cutTable.value.toggleRowSelection(row, true)
    row.flows.map(e => {
      if(!row.flowInvoiceId){
        cusFlowsSeleRows.value.push(e)
        cutTable.value.toggleRowSelection(e, true)
      }
    })
    
  })
}

const custSelectable = (row: any, index: number) => {
  // 最外行, 未下拉加载不可选择
  if(row.hasChildren === true && !row.flows){
    return false
  }
  // 不是子行,也没有children
  if(!row.hasChildren && !row.hasOwnProperty('flowInvoiceId')){
    return false
  }
  // flowInvoiceId不为null,则不可选择
  if(!row.hasChildren && row.flowInvoiceId !== null){
    return false
  }
  return true

}



const {
  MI_tableData: invData, fetchData: fetchInv, page: invPage, size: invSize, MI_total: invTotal, MI_pageChange: invPageChange,
  MI_sizeChange: invSizeChange, MI_identify: invIdentify, MI_params: InvParams
} = new tbMix(fetchInvoiceList)

const invSearchEle = ref()
const invOrderTableEle = ref()
let InvOrderRows: any = ref([])
let emptyInvRows: any = ref([])
const InvSearchConfig = ref([
  {
    label: '客户名称',
    value: '',
    upKey: 'client',
    props: { clearable: true },
  },
  {
    label: '客户ID',
    value: '',
    upKey: 'clientUsername',
    props: { clearable: true },
  },
  {
    label: '发票号码',
    value: '',
    upKey: 'no',
    props: { clearable: true},
  },
  {
    type: 'SELECT',
    label: '币种',
    value: '',
    upKey: 'currency',
    options: currencyOption(),
    props: { clearable: true, placeholder: '请选择币种', },
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
  {
    type: "TIME",
    label: "交易日期",
    value: [],
    upKey: 'daterange',
    props: {
      'value-format': 'YYYY-MM-DD',
      type: 'daterange',
      clearable: true,
    }
  },
  {
    type: 'SELECT',
    label: '是否历史记录',
    value: '',
    upKey: 'history',
    options: [
      { label: '是', id: true },
      { label: '否', id: false },
    ],
    props: { clearable: true, placeholder: '请选择是否历史记录', },
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
  {
    type: "SELECT",
    label: "组",
    value: "",
    upKey: "group",
    options: gruopList,
    seleProps: { label: "label", valueName: "id",},
    props: { placeholder: "请选择组", clearable: true, 'allow-create': true },
  },
  {
    type: 'SELECT',
    label: '是否勾销',
    value: '',
    upKey: 'verify',
    options: [
      { label: '是', id: true },
      { label: '否', id: false },
    ],
    props: { clearable: true },
    placeholder: '请选择是否勾销',
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  {
    type: 'SELECT',
    label: '排序',
    value: 'no',
    upKey: 'sort',
    options: [
      { label: '发票日期', id: 'date'},
      { label: '发票编号', id: 'no' },
    ],
    props: {clearable: false, placeholder: '请选择排序',},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '发票状态',
    value: 'WAIT_DELIVERED',
    upKey: 'status',
    options: [
      { label: '待交付', id: 'WAIT_DELIVERED'},
      { label: '已交付', id: 'DELIVERED' },
    ],
    props: {clearable: false, placeholder: '请选择发票状态',},
    seleProps: { label: 'label', valueName: 'id', },
  },
  /* {
    type: 'SELECT',
    label: '是否客户流水发票',
    value: false,
    upKey: 'co2',
    options: [
      { label: '是', id: true },
      { label: '否', id: false },
    ],
    props: { clearable: false, placeholder: '请选择是否客户流水发票', },
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  }, */

])

// const InvParams = reactive({})
// const InvIdentify = ref(false)
const invoiceData: any = ref([])
const invoiceDisabled = ref(false);
const invoicePage = ref(1);
const invoiceTotal = ref(100);

const invSerachHandle = (params: any, isLoad = true) => {
  // Object.assign(InvParams, params)
  // 判断是否搜索客户流水发票
  /* if(isLoad === true){
    invoicePage.value = 1
    invoiceData.value = []
  } */
  // InvIdentify.value = true
  fetchInv({
    // 客户流水发票参数
    ...flowsParams,
    ...params,
    // page: invoicePage.value, size: 30,
    date: {
      from: params.daterange? params.daterange[0] : '', 
      to: params.daterange? params.daterange[1] : ''
    },
    ...props.salesmanParams
  }).then((rep: any) => {
    // invoiceData.value.push(...rep.data)
    // invoiceData.value = invoiceData.value.concat(rep.data)
    // invoiceTotal.value = Math.ceil(rep.rowCount / 30)
  }).finally(() => {
    // InvIdentify.value = false
  })
}

/* const invoiceLoad = () => {
  if (invoiceDisabled.value || InvIdentify.value === true || invoiceData.value.length === 0) return;
  invoicePage.value ++;
  if (invoicePage.value <= invoiceTotal.value) {
    invSerachHandle(InvParams, false)
  }
  // 禁用滚动
  if (invoicePage.value === invoiceTotal.value) {
    invoiceDisabled.value = true;
  }
} */

const invOrdSelectable = (row: any, index: number) => {
  if(row.orders?.length > 0 && row.notVerifiedAmount === 0){
    return false
  }
  if(row.orders?.length === 0 && row.flowInvoiceId !== null){
    return false
  }
  if(row.hasOwnProperty('verifyTime') && row.verifyTime !== null){
    return false
  }

  if(bindOrderIds.value.includes(row.no)){
    return false
  }
  return true
}
const selectInvOrderRows = (selection: any, row: any) => {
  const isSelect = selection.some((seleRow: {id: number}) => {
    // 判断发票是否已勾选
    if(row.order){
      return row.no === seleRow.no
    }
    // 判断订单是否已勾选
    return row.id === seleRow.id
  })
  // 如果勾选的是发票
  if(row.orders && row.orders.length === 0){
    let index = emptyInvRows.value.findIndex((inv: any) => inv.no === row.no)
    // 添加发票
    if(isSelect && index === -1){
      emptyInvRows.value.push(row)
    }
    if(!isSelect && index !== -1){
      emptyInvRows.value.splice(index, 1)
    }
    return
  }
  if(row.orders){
    row.orders.map((_order: any) => {
      let index = InvOrderRows.value.findIndex((item: any) => item.id === _order.id)
      // 勾选
      if(isSelect && index === -1 && _order.verifyTime === null){
        InvOrderRows.value.push(_order)
      } 
      if(!isSelect && index !== -1 && _order.verifyTime === null){
        InvOrderRows.value.splice(index, 1)
      }
      _order.verifyTime === null && invOrderTableEle.value.toggleRowSelection(_order, !!isSelect)
    })
    return
  }
  let index = InvOrderRows.value.findIndex((item: any) => item.id === row.id)
  if(isSelect && index === -1){
    InvOrderRows.value.push(row)
  } else if(!isSelect && index !== -1) {
    InvOrderRows.value.splice(index, 1)
  }
}
let isFullSeleInv = false
const selectAllInv = (selection: any) => {
  // true为全选
  isFullSeleInv = !isFullSeleInv

  // 统一取消全选
  InvOrderRows.value = []
  emptyInvRows.value = []
  invOrderTableEle.value.clearSelection()
  if(!isFullSeleInv) return;


  // 全选
  selection.map(row => {
    if(!row.orders || row.orders.length === 0 ) {
      if(row.flowInvoiceId === null){
        emptyInvRows.value.push(row)
        invOrderTableEle.value.toggleRowSelection(row, true)
      }
      return
    }
    row.orders.map(e => {
      // 添加可以核销的发票
      if(e.verifyTime === null){
        InvOrderRows.value.push(e)
        invOrderTableEle.value.toggleRowSelection(e, true)
      }
    })
    invOrderTableEle.value.toggleRowSelection(row, true)
    
  })
  
}
// -------订单列表-----
const orderSearchEle: any = ref()
const orderEle = ref()
let orderRows: any = ref([])

const ordreSearchCfg = ref([
  {
    label: "订单编号",
    value: '',
    upKey: 'no',
    props: { clearable : true }
  },
  {
    label: "客户名称",
    value: '',
    upKey: 'customerName',
    props: { clearable : true }
  },
  {
    label: "客户ID",
    value: '',
    upKey: 'customerId',
    props: { clearable : true }
  },
  {
    type: "TIME",
    label: "起始完工时间",
    value: '',
    upKey: 'deliverTimeFrom',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "结束完工时间",
    value: '',
    upKey: 'deliverTimeTo',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "起始关单时间",
    value: '',
    upKey: 'closeTimeFrom',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "结束关单时间",
    value: '',
    upKey: 'closeTimeTo',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "起始确认关单时间",
    value: '',
    upKey: 'confirmCloseTimeFrom',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "结束确认关单时间",
    value: '',
    upKey: 'confirmCloseTimeTo',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "开始回款时间",
    value: '',
    upKey: 'financialTimeFrom',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "结束回款时间",
    value: '',
    upKey: 'financialTimeTo',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "开始核销时间",
    value: '',
    upKey: 'verifyTimeFrom',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "结束核销时间",
    value: '',
    upKey: 'verifyTimeTo',
    props: {
      clearable: true,
    }
  },
  {
    type: 'SELECT',
    label: '类型',
    value: '',
    upKey: 'dateType',
    options: [
      { label: '按年份', id: 'year' },
      { label: '按月份', id: 'month' },
      { label: '按季度', id: 'quarter' },
    ],
    props: { placeholder: '请选择类型', clearable: true },
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  {
    type: 'SELECT',
    label: '关单与确认关单',
    value: '',
    upKey: 'noEqualTime',
    options: [
      { label: '时间不相等', id: true },
    ],
    props: { clearable: true, placeholder: '请选择是否相等', },
    seleProps: { label: 'label', valueName: 'id', }
  },
  /* {
    type: 'SELECT',
    label: '状态',
    value: '',
    upKey: 'statusList',
    options: orderOption,
    props: {clearable: true, placeholder: '请选择订单状态', multiple: true, 'collapse-tags': true },
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  }, */
  {
    type: 'SELECT',
    label: '国内外收入',
    value: '',
    upKey: 'domestic',
    options: [
      { label: '国内', id: 'true'},
      { label: '国外', id: 'false' },
    ],
    props: {clearable: true, placeholder: '请选择国内外收入'},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '国内外订单设置',
    value: '',
    upKey: 'unSetDomestic',
    options: [
      { label: '未设置', id: 'true'},
      { label: '全部订单', id: 'false' },
    ],
    props: {clearable: true, placeholder: '请选择国内外收入'},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '币种',
    value: [],
    upKey: 'currency',
    options: currencyOption(),
    props: {clearable: true, placeholder: '请选择币种', multiple: true, 'collapse-tags': true},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
  {
    type: 'SELECT',
    label: 'deliverTimes是否为空',
    value: '',
    upKey: 'isNullDeliverTime',
    options: [
      { label: '为空', id: 'true'},
      { label: '不为空', id: 'false' },
    ],
    props: {clearable: true, placeholder: '请选择国内外收入'},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: "TIME",
    label: "开始时间范围",
    value: '',
    upKey: 'startTimeFrom',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "结束时间范围",
    value: '',
    upKey: 'startTimeTo',
    props: {
      clearable: true,
    }
  },
  orgCfig({
    upKey: 'coTwoOrgId'
  }),
  {
    type: 'SELECT',
    label: '订单类别',
    value: '',
    upKey: 'categoryId',
    options: orderCategorysOption,
    props: {clearable: true, placeholder: '请选择订单类别' },
    seleProps: { label: 'label', valueName: 'categoryId' },
  },  
  {
    type: 'SELECT',
    label: '发票主体',
    value: '',
    upKey: 'invoiceCompany',
    options: companyInvice,
    props: {clearable: true, placeholder: '请选择发票主体', multiple: true, "collapse-tags": true, style: 'width: 325px'},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
])
// 订单
const ordParams = reactive({})
const ordIdentify = ref(false)
const orderData = ref([])
const orderDisabled = ref(false);
const orderPage = ref(1);
const orderTotal = ref(100);

const ordSearch = (params: any, isLoad = true) => {
  Object.assign(ordParams, params)
  if(isLoad === true){
    orderPage.value = 1
    orderData.value = []
  }
  ordIdentify.value = true
  orderListApi({
    ...flowsParams,
    ...params,
    statusList: params.statusList || [],
    invoiceCompany: params.invoiceCompany || [],
    startTimeRange: params.startTimeRange || {},
    statusList: ['delivered'],
    page: orderPage.value, size: 30,
    ...props.salesmanParams
  }).then((rep: any) => {
    // orderData.value = orderData.value.concat(rep.data)
    orderData.value.push(...rep.data)
    orderTotal.value = Math.ceil(rep.rowCount / 30)
  }).finally(() => {
    ordIdentify.value = false
  })
}

const orderLoad = () => {
  if (orderDisabled.value || ordIdentify.value === true || orderData.value.length === 0) return;
  orderPage.value ++;
  if (orderPage.value <= orderTotal.value) {
    ordSearch(ordParams, false)
  }
  // 禁用滚动
  if (orderPage.value === orderTotal.value) {
    invoiceDisabled.value = true;
  }
}











// 已选择订单列表
const selectedOrder = computed(() => {
  return orderRows.value.concat(InvOrderRows.value)
})

// 未匹配客户流水
const unmatchEle = ref()
const isShowUnmatch = ref<boolean>(false)
let unCustomerRows = ref([])
const unMatchConfig = ref([
  {
    label: '流水ID',
    value: '',
    upKey: 'flowId',
    props: { clearable: true },
  },
  {
    label: '收付方名称',
    value: '',
    upKey: 'costTo',
    props: { clearable: true },
  },
  {
    type: 'NUMBER',
    label: '收款金额',
    value: undefined,
    upKey: 'receiptAmount',
    props: { clearable: true },
  },
  {
    type: "TIME",
    label: "流水日期范围",
    value: [],
    upKey: 'dates',
    upProps: {startKey: 'collectionFrom', endKey: 'collectionto'},
    props: {
      type: 'daterange',
      'value-format': 'YYYY-MM-DD'
    }
  },
])
const {
  MI_tableData: unmatchDate, fetchData: unmatchFetch, page: unmatchPage, size: unmatchSize, MI_total: unmatchTotal, MI_pageChange: unmatchPgChnage,
  MI_sizeChange: unmatchSzChange, MI_identify: unmatchIdentify, MI_params: unmatchParams
} = new tbMix(not_match_flowApi)

const showUnmatchHandle = () => {
  isShowUnmatch.value = true
  unmatchFetch(unmatchParams).then(() => {
    // 如果勾销成功,未匹配多选list会自动清空
    if(unCustomerRows.value.length === 0){
      unmatchEle.value.clearSelection()
    }
  })
}
const resetUnmatchHandle = () => {
  // 清空未匹配表格多选
  unmatchEle.value.clearSelection()
  ElMessage.info('已清空未匹配流水勾选')
}

const umatchSearchHandle = (params: any) => {
  unmatchFetch({
    ...params,
    collectionFrom: params.dates ? params.dates[0] : '',
    collectionto: params.dates ? params.dates[1] : '',
    ...props.salesmanParams
  })
}

// 客户流水金额合计
const cusFlowsCouont = computed(() => {
  // 客户流水 + 未匹配客户流水 + 流水
  return cusFlowsSeleRows.value.concat(unCustomerRows.value, singleFlowsEle.value?.seleRows || []).reduce((numb: number, _flow: any,) => {
    if(_flow.flows || !_flow.receiptAmount) return numb;
    // 统计收款金额
    return numb += _flow.receiptAmount
  }, 0)
})


// 订单金额合计
const invOrderCount = computed(() => {
  return InvOrderRows.value.reduce((numb: number, _flow: any,) => {
    return numb += parseFloat(_flow.amount || 0)
  }, 0)
})

const orderRowsCount = computed(() => {
  return orderRows.value.reduce((numb: number, _flow: any,) => {
    return numb += parseFloat(_flow.amount || 0)
  }, 0)
})

// 根据客户id搜索订单和发票
const searchOrderInv = (row: any) => {
  // 发票订单表格处理
  invOrderTableEle.value.clearSelection()
  InvOrderRows.value = []

  invSearchEle.value.resetForm()
  invSearchEle.value.dataObj.clientUsername = row.customerId
  invSearchEle.value.dataObj.verify = false
  invSearchEle.value.submitHandle()

  // 订单表格处理
  orderSearchEle.value.resetForm()
  orderSearchEle.value.dataObj.customerId = row.customerId
  orderSearchEle.value.submitHandle()
  // cutTable.value.toggleRowExpansion(row)
}



// 重置所有表格多选
const resetAllSelection = () => {
  cutTable.value.clearSelection()
  singleFlowsEle.value.resetRows()
  invOrderTableEle.value.clearSelection()
  orderEle.value.clearSelection()

  cusFlowsSeleRows.value = []
  orderRows.value = []
  emptyInvRows.value = []
  InvOrderRows.value = []
  // 清空未匹配流水
  unCustomerRows.value = []

  flowsParams.idStr = []
}
// 勾销成功
const compareSuccessHandle = () => {
  resetAllSelection()
  // 重新搜索
  invSerachHandle(InvParams)
  ordSearch(ordParams)
}


// 订单选择绑定关系
let flowOrderbindMap: any = {}
let bindOrderIds: any = ref<number[]>([]) // 所有需要锁定多选的订单id

const orderSelectable = (row: any) => {
  return row.verifyTime === null && !bindOrderIds.value.includes(row.no)
}
let waitCancelRows: string[] = [] // 此次需要需要勾选的订单
watch(() => singleFlowsEle.value?.seleRows, (arr) => {
  // 此次勾选流水ids
  const ids = arr.map((e: {id: number}) => e.id)
  // 获取有对应流水的订单
  const targetIds: string[] = Object.keys(flowOrderbindMap)
  if(targetIds.length === 0) return;
 
  // 获取所有需要勾选的订单
  let duplicates = ids.reduce((arr: number[], flowId: number) => {
    if(targetIds.includes(flowId.toString()) && !!flowOrderbindMap[flowId.toString()]){
      return arr.concat(flowOrderbindMap[flowId.toString()])
    }
    return arr
  }, [])
  
  // 获取相比上次取消勾选的流水 
  waitCancelRows = []
  bindOrderIds.value.map((flowId: number) => {
    if(!duplicates.includes(flowId)){
      waitCancelRows.push(flowId.toString())
    }
  })

  console.log(duplicates, waitCancelRows);
  bindOrderIds.value = duplicates
  // 获取自动勾选或取消勾选的订单
  orderData.value.map((row: {no: string}) => {
    if(waitCancelRows.includes(row.no)){
      orderEle.value.toggleRowSelection(row, false)
    }
    if(duplicates.includes(row.no)){
      orderEle.value.toggleRowSelection(row, true)
    }
  })
  // 获取自动勾选或取消勾选发票下的订单

  invData.value.map((row: {orders: {no: string}[]}) => row.orders).flat().map((row: {no: string}) => {
    if(waitCancelRows.includes(row.no)){
      invOrderTableEle.value.toggleRowSelection(row, false)
      
      selectInvOrderRows([], row)
    }
    if(duplicates.includes(row.no)){
      invOrderTableEle.value.toggleRowSelection(row, true)
      selectInvOrderRows([row], row)
    }
  })
})

// 获取客户流水发票
const flowsParams = reactive({
  verify: false,
  idStr: []
})
const isShowGetFlows = ref<boolean>(false)
const getFlowsHandle = async () => {
  // 添加流水表格,搜索参数
  const idStr = singleFlowsEle.value?.seleRows.map((flow: {id: number}) => flow.id)
  flowsParams.idStr = idStr

  // 获取流水对应的订单
  flowOrderbindMap = await orders_of_flow_productApi({idStr})


  singleFlowsEle.value.fetchData({query: {...flowsParams, collectionAt: {}, createdAt: {}, paymentType: '翻译收入'}}).then(() => {
    singleFlowsEle.value.resetRows()
  })
  // 清空发票订单搜索
  invSearchEle.value.resetForm()
  invSearchEle.value.dataObj.verify = flowsParams.verify === false ? false : ''
  invSearchEle.value.submitHandle()
  // 清空订单搜索
  orderSearchEle.value.resetForm()
  orderSearchEle.value.submitHandle()

  isShowGetFlows.value = false

}








const calculateFg = ref(false)
const calculateConfig = ref([
  {
    type: "TIME",
    label: "开始时间",
    value: '',
    upKey: 'start',
    props: {
      'value-format': 'YYYY-MM-DD',
      type: 'date',
      clearable: true,
    },
    rule: [
      { required: true, message: '请输选择开始时间', trigger: 'change' },
    ],
  },
  {
    type: "TIME",
    label: "结束时间",
    value: '',
    upKey: 'end',
    props: {
      'value-format': 'YYYY-MM-DD',
      type: 'date',
      clearable: true,
    },
    rule: [
      { required: true, message: '请输选择结束时间', trigger: 'change' },
    ],
  },
])

// 计算流水本位币
const flowFg = ref<boolean>(false)
const calculateFlow = () => {
  MI_modifyForm({}, calculateConfig, flowFg, async (parmas: any) => {
    await compute_flow_rateApi(parmas, { contentType: 'formData'})
    ElMessage.success('成功')
    flowFg.value = false
    singleFlowsEle.value.fetchData(singleFlowsEle.value.MI_params)
  })
}
// 计算发票本位币
const calculateInv = () => {
  MI_modifyForm({}, calculateConfig, calculateFg, async (parmas: any) => {
    await compute_invoice_rateApi(parmas, { contentType: 'formData'})
    ElMessage.success('成功')
    calculateFg.value = false
    invSerachHandle(InvParams)
  })
}

// 导入
const isShowImport = ref<boolean>(false)
const importNoList = ref('')
const showImport = () => {
  // 必须选择客户
  if(flowsListType.value === false && singleFlowsEle.value?.seleRows.length === 0 ){
    // 展示流水时
    ElMessage.warning('请选择一条流水')
    return
  }

  if(flowsListType.value === true && cusFlowsSeleRows.value.length === 0 ){
    // 展示客户流水时
    ElMessage.warning('请选择一条客户流水')
    return
  }


  importNoList.value = ''
  isShowImport.value = true
}

const submitImport = () => {
  let result;
  nosApi({
    ...props.salesmanParams,
    noList: importNoList.value,
    customerIds: flowsListType.value === true ? cusFlowsSeleRows.value[0].customerId : singleFlowsEle.value?.seleRows.reduce((arr: string[], item: any) => {
      arr = arr.concat(item.customerIds)
      return arr
    }, [])
  }).then((rep) => {
    result = rep
    if(rep.invalidNos && rep.invalidNos.length > 0){
      return ElMessageBox.confirm(rep.invalidNos.join(','), '请确认存在问题的订单号/发票号', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
    }

    return Promise.resolve(rep)
  }).then(() => {
    const {invoices, orders} = result
    isShowImport.value = false
    importNoList.value = ''
    ElMessage.success('获取成功')
    // 先清空表格
    resetAllSelection()
    // selectedOrder.value = []

    invPage.value = 1
    invData.value = invoices
    invTotal.value = invoices.length
    invOrderTableEle.value.toggleAllSelection()


    orderPage.value = 1
    orderData.value = orders
    orderTotal.value = orders.length
    orderEle.value.toggleAllSelection()

    if(invoices.length === 0 && orders.length === 0){
      ElMessage.info('订单和发票为空')
    }
  }).catch(() => {})
}


// 导出订单
const exportSeleOrder = () => {
  exportHandle(exportNosApi, {orderNos: selectedOrder.value.map(e => e.no)})
}




// -------流水订单勾销参数---------
const compareProps = computed(() => {
  return {
    flowRows: cusFlowsSeleRows.value.concat(unCustomerRows.value, singleFlowsEle.value?.seleRows || []),
    invRows: emptyInvRows.value,
    orderRows: selectedOrder.value,
  }
})
// -------发票表格颜色------
const invRowClassName = ({ row, rowIndex }: any) => {
  if (row.del === true ) {
    return 'grayRow'
  }
  if (row.flowInvoiceId !== null && row.hasOwnProperty('orders')) {
    return 'blueInvRow'
  }
  if (row.flowId !== null && !row.hasOwnProperty('orders')) {
    return 'blueInvRow'
  }
  if (row.history === true ) {
    return 'greenInvRow'
  }
  return ''
}
const test = () => {
  console.log(InvOrderRows.value, orderRows.value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_switch, {
      modelValue: flowsListType.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((flowsListType).value = $event)),
      "inline-prompt": "",
      "active-text": "客户",
      "inactive-text": "流水",
      style: {"--el-switch-off-color":"#13ce66"}
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_divider, { direction: "vertical" }),
    _createElementVNode("span", _hoisted_1, " 流水收款金额合计：" + _toDisplayString(_unref(getNumber)(_unref(cusFlowsCouont))), 1),
    _createElementVNode("span", {
      class: "numberRectangle mr-10",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (test()))
    }, " 订单金额合计：" + _toDisplayString(_unref(getNumber)(_unref(invOrderCount) + _unref(orderRowsCount))), 1),
    _createVNode(_component_el_divider, { direction: "vertical" }),
    _createVNode(FlowOrderCompare, _mergeProps(_unref(compareProps), {
      onCompareSuccess: _cache[2] || (_cache[2] = ($event: any) => (compareSuccessHandle()))
    }), null, 16),
    _createVNode(_component_el_divider, { direction: "vertical" }),
    _createVNode(_component_el_button, {
      onClick: _cache[3] || (_cache[3] = ($event: any) => {isShowGetFlows.value = true; _unref(flowsParams).verify = true}),
      disabled: singleFlowsEle.value?.seleRows.length === 0
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_badge, {
      value: _unref(unCustomerRows).length,
      class: "mr-10 ml-10",
      type: "primary"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (showUnmatchHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_el_button, {
      onClick: _cache[5] || (_cache[5] = ($event: any) => (calculateFlow()))
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[6] || (_cache[6] = ($event: any) => (calculateInv()))
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[7] || (_cache[7] = ($event: any) => (showImport()))
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[8] || (_cache[8] = ($event: any) => (resetAllSelection()))
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }),
    _createVNode(_component_el_popover, {
      placement: "bottom",
      width: 400,
      trigger: "hover"
    }, {
      reference: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "ml-10",
          type: "info"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_divider, null, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _createVNode(_component_el_divider, null, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }),
        _hoisted_15,
        _hoisted_16,
        _hoisted_17
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      gutter: 20,
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 12,
          style: {"perspective":"2000px","position":"relative","min-height":"570px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_Transition, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_el_collapse, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_collapse_item, { title: "客户流水分组-搜索" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_FlexibleForm, _mergeProps({ ref: "custSearchEle" }, {
                    title: true,
                    initSearch: true,
                    searchConfig: custConfig.value,
                  }, {
                            onSearchFn: _cache[9] || (_cache[9] = ($event: any) => (searchCustomerHandle($event)))
                          }), null, 16)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    data: _unref(custData),
                    ref_key: "cutTable",
                    ref: cutTable,
                    border: "",
                    "tree-props": { children: 'flows', hasChildren: 'hasChildren' },
                    "row-key": "id",
                    lazy: "",
                    load: loadFlowRow,
                    onSelect: seleCustomerRow,
                    onSelectAll: seleFullCustomer,
                    "max-height": _unref(MI_height) / 2.2 + 'px'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        type: "selection",
                        width: "50",
                        fixed: "",
                        selectable: custSelectable
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "客户(收付方名称)",
                        prop: "customer",
                        "show-overflow-tooltip": "",
                        width: "150",
                        fixed: ""
                      }, {
                        default: _withCtx(({ row }) => [
                          (row.flowQuantity != undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                _createElementVNode("span", _hoisted_20, _toDisplayString(row.flowQuantity), 1),
                                _createTextVNode(" " + _toDisplayString(row.customer), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                (!row.flowInvoiceId)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(row.costTo), 1))
                                  : (_openBlock(), _createBlock(_component_el_link, {
                                      key: 1,
                                      type: "primary",
                                      onClick: ($event: any) => (_ctx.$router.push({ path: '/balance-list', query:{ id: row.flowInvoiceId }}))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(row.costTo), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                              ]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "客户ID(订单ID)",
                        prop: "customerId",
                        "show-overflow-tooltip": "",
                        width: "150"
                      }, {
                        default: _withCtx(({ row }) => [
                          (row.flowQuantity != undefined)
                            ? (_openBlock(), _createBlock(_component_el_link, {
                                key: 0,
                                type: "primary",
                                disabled: _unref(invIdentify) || ordIdentify.value,
                                onClick: ($event: any) => (searchOrderInv(row))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row.customerId), 1)
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(row.id), 1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "收款币别",
                        prop: "receiptCurrency",
                        width: "100"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "收款金额",
                        prop: "receiptAmount",
                        width: "115",
                        align: "right",
                        sortable: ""
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("span", null, [
                            (row.flowQuantity != undefined)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(getNumber)(row.flowAmountTotal)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_unref(getNumber)(row.receiptAmount)), 1))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "本位币",
                        prop: "standardMoney",
                        width: "115",
                        align: "right",
                        formatter: _unref(formatNumber),
                        "show-overflow-tooltip": "",
                        sortable: ""
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "回款日期",
                        prop: "collectionAt",
                        width: "115",
                        sortable: "",
                        "show-overflow-toolti": ""
                      }, {
                        default: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(row.collectionAt ? _unref(dayjs)(row.collectionAt).format('YYYY-MM-DD HH:mm:ss') : ''), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "公司名称",
                        prop: "costFrom",
                        width: "230",
                        "show-overflow-tooltip": ""
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "账户简称",
                        prop: "accountName",
                        width: "135",
                        "show-overflow-tooltip": ""
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "币种",
                        prop: "currency"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "借方",
                        prop: "costOut",
                        align: "right",
                        width: "100",
                        formatter: _unref(formatNumber)
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "贷方",
                        prop: "costIn",
                        width: "100",
                        align: "right",
                        formatter: _unref(formatNumber)
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "手续费",
                        prop: "handlingFee",
                        align: "right",
                        width: "100",
                        formatter: _unref(formatNumber)
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "银行摘要",
                        prop: "summary",
                        width: "200",
                        "show-overflow-tooltip": ""
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "款项类型",
                        prop: "paymentType",
                        width: "120"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "备注",
                        prop: "remarks",
                        width: "130",
                        "show-overflow-tooltip": ""
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "匹配核销备注",
                        prop: "matchRemarks",
                        width: "150",
                        "show-overflow-tooltip": ""
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "团队",
                        prop: "team",
                        "show-overflow-tooltip": ""
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "销售",
                        prop: "saler",
                        "show-overflow-tooltip": ""
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "匹配状态",
                        width: "115",
                        prop: "matchStatus"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(row.matchStatus === 'Matched' ? '已匹配' : '未匹配'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "勾销状态",
                        width: "115",
                        prop: "verifyStatus"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(row.verifyStatus === null ? '未勾销' : row.verifyStatus === 'Verified' ? '已勾销' : '部分勾销'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "状态",
                        prop: "status"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "导入批次",
                        prop: "fileId",
                        width: "150"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "账户ID",
                        prop: "accountNumber",
                        "show-overflow-tooltip": ""
                      })
                    ]),
                    _: 1
                  }, 8, ["data", "max-height"])), [
                    [_directive_loading, _unref(custIdentify)]
                  ]),
                  _createVNode(_component_el_pagination, {
                    small: "",
                    style: {"float":"none"},
                    total: _unref(custTotal),
                    class: "mt-10",
                    currentPage: _unref(custPage),
                    "onUpdate:currentPage": _cache[10] || (_cache[10] = ($event: any) => (_isRef(custPage) ? (custPage).value = $event : null)),
                    "page-size": _unref(custSize),
                    "onUpdate:page-size": _cache[11] || (_cache[11] = ($event: any) => (_isRef(custSize) ? (custSize).value = $event : null)),
                    "page-sizes": [10, 30, 50, 100, 300],
                    layout: "sizes, prev, pager, next, total, jumper",
                    onCurrentChange: _unref(custPageChange),
                    onSizeChange: _unref(custSizeChange)
                  }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
                ], 512), [
                  [_vShow, flowsListType.value]
                ])
              ]),
              _: 1
            }),
            _createVNode(_Transition, { name: "flows" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_26, [
                  _createVNode(SingleFlows, {
                    ref_key: "singleFlowsEle",
                    ref: singleFlowsEle,
                    showBtn: false,
                    "max-height": _unref(MI_height) / 2.5 + 'px',
                    searchParams: {...props.salesmanParams}
                  }, null, 8, ["max-height", "searchParams"])
                ], 512), [
                  [_vShow, !flowsListType.value]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, { title: "发票查询" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FlexibleForm, _mergeProps({
                      ref_key: "invSearchEle",
                      ref: invSearchEle
                    }, {
                title: true,
                initSearch: false,
                searchConfig: InvSearchConfig.value,
              }, { onSearchFn: invSerachHandle }), {
                      custom: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              onSelect: selectInvOrderRows,
              onSelectAll: selectAllInv,
              ref_key: "invOrderTableEle",
              ref: invOrderTableEle,
              border: "",
              data: _unref(invData),
              "tree-props": { children: 'orders' },
              height: _unref(MI_height) / 2.1 + 'px',
              "row-key": (row) => row.orders ?  row.no : row.id,
              "row-class-name": invRowClassName
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "45",
                  fixed: "",
                  "reserve-selection": "",
                  selectable: invOrdSelectable
                }),
                _createVNode(_component_el_table_column, {
                  label: "编号",
                  prop: "no",
                  "show-overflow-tooltip": "",
                  fixed: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "币种",
                  prop: "currency",
                  width: "70"
                }),
                _createVNode(_component_el_table_column, {
                  label: "金额(原始金额)",
                  prop: "invoiceAmount",
                  width: "150",
                  align: "right",
                  sortable: ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(_unref(getNumber)(row.invoiceAmount || row.amount)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "已勾销金额",
                  prop: "verifiedAmount",
                  width: "120",
                  align: "right",
                  sortable: ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(_unref(getNumber)(row.verifiedAmount)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "剩余金额",
                  prop: "notVerifiedAmount",
                  align: "right",
                  sortable: "",
                  width: "120"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(_unref(getNumber)(row.notVerifiedAmount)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "境内外",
                  prop: "domestic",
                  formatter: (row) => row.domestic === true ? '境内': '境外'
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "税费",
                  prop: "taxRate",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "客户名称",
                  prop: "client",
                  "show-overflow-tooltip": "",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "交付日期",
                  prop: "deliverTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"])
              ]),
              _: 1
            }, 8, ["data", "height", "row-key"])), [
              [_directive_loading, _unref(invIdentify)]
            ]),
            _createVNode(_component_el_pagination, {
              total: _unref(invTotal),
              small: "",
              currentPage: _unref(invPage),
              "onUpdate:currentPage": _cache[12] || (_cache[12] = ($event: any) => (_isRef(invPage) ? (invPage).value = $event : null)),
              "page-size": _unref(invSize),
              "onUpdate:page-size": _cache[13] || (_cache[13] = ($event: any) => (_isRef(invSize) ? (invSize).value = $event : null)),
              disabled: _unref(invIdentify),
              class: "mt-5",
              style: {"float":"none"},
              "page-sizes": [30, 50, 100, 300, 500],
              layout: "sizes, prev, pager, next, total, jumper",
              onCurrentChange: _unref(invPageChange),
              onSizeChange: _unref(invSizeChange)
            }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 12,
          class: "pt-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "mb-10",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (exportSeleOrder()))
            }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            }),
            _createVNode(_component_el_table, {
              data: _unref(selectedOrder),
              border: "",
              "max-height": _unref(MI_height) / 2 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "订单编号",
                  prop: "no",
                  "show-overflow-tooltip": "",
                  fixed: ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "100",
                  label: "发票编号",
                  prop: "invoiceNo",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "币种",
                  prop: "currency",
                  width: "65"
                }),
                _createVNode(_component_el_table_column, {
                  label: "金额",
                  prop: "amount",
                  align: "right",
                  formatter: _unref(formatNumber),
                  "show-overflow-tooltip": "",
                  width: "125"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "客户ID",
                  prop: "customerUsername",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "客户名称",
                  prop: "customer",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "境内外",
                  prop: "domestic",
                  "show-overflow-tooltip": "",
                  formatter: (row) => row.domestic === true ? '境内' : '境外'
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "发票主体",
                  prop: "invoiceCompany",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "回款公司",
                  prop: "flowCompany",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "订单名称",
                  prop: "name",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "po号",
                  prop: "poNumber",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "本位币",
                  prop: "standardMoney",
                  width: "100",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "USD金额",
                  prop: "baseCurrencyMoney",
                  align: "right"
                }, {
                  default: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(_unref(getNumber)(parseFloat(row.baseCurrencyMoney))), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "状态",
                  prop: "status",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "客户经理",
                  prop: "owner",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "开始时间",
                  prop: "startTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "完工时间",
                  prop: "deliverTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "确认完工时间",
                  prop: "confirmDeliverTime",
                  formatter: _unref(formatTime),
                  width: "120",
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "关单时间",
                  prop: "closeTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "确认关单时间",
                  prop: "confirmCloseTime",
                  formatter: _unref(formatTime),
                  width: "120",
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "回款时间",
                  prop: "financialTime",
                  formatter: _unref(formatTime),
                  width: "120",
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "核销时间",
                  prop: "verifyTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "财务费用",
                  prop: "financialExpenses",
                  align: "right",
                  formatter: _unref(formatNumber),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "坏账",
                  prop: "badDebt",
                  align: "right",
                  formatter: _unref(formatNumber),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"])
              ]),
              _: 1
            }, 8, ["data", "max-height"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, { class: "mt-10" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, { title: "订单查询" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FlexibleForm, _mergeProps({
                      ref_key: "orderSearchEle",
                      ref: orderSearchEle
                    }, {
                initSearch: false,
                title: true,
                searchConfig: ordreSearchCfg.value,
              }, { onSearchFn: ordSearch }), null, 16)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              ref_key: "orderEle",
              ref: orderEle,
              data: orderData.value,
              border: "",
              "infinite-scroll-disabled": orderDisabled.value,
              onSelectionChange: _cache[15] || (_cache[15] = (rows) => _isRef(orderRows) //@ts-ignore
 ? orderRows.value = rows : orderRows = rows),
              height: _unref(MI_height) / 2.1 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "50",
                  fixed: "",
                  selectable: orderSelectable
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "订单编号",
                  prop: "no",
                  "show-overflow-tooltip": "",
                  fixed: ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "100",
                  label: "发票编号",
                  prop: "invoiceNo",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "币种",
                  prop: "currency",
                  width: "65"
                }),
                _createVNode(_component_el_table_column, {
                  label: "金额",
                  prop: "amount",
                  align: "right",
                  formatter: _unref(formatNumber),
                  "show-overflow-tooltip": "",
                  width: "125"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "客户ID",
                  prop: "customerUsername",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "客户名称",
                  prop: "customer",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "境内外",
                  prop: "domestic",
                  "show-overflow-tooltip": "",
                  formatter: (row) => row.domestic === true ? '境内' : '境外'
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "发票主体",
                  prop: "invoiceCompany",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "回款公司",
                  prop: "flowCompany",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "订单名称",
                  prop: "name",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "po号",
                  prop: "poNumber",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "本位币",
                  prop: "standardMoney",
                  width: "100",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "USD金额",
                  prop: "baseCurrencyMoney",
                  align: "right"
                }, {
                  default: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(_unref(getNumber)(parseFloat(row.baseCurrencyMoney))), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "状态",
                  prop: "status",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "客户经理",
                  prop: "owner",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "开始时间",
                  prop: "startTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "完工时间",
                  prop: "deliverTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "确认完工时间",
                  prop: "confirmDeliverTime",
                  formatter: _unref(formatTime),
                  width: "120",
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "关单时间",
                  prop: "closeTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "确认关单时间",
                  prop: "confirmCloseTime",
                  formatter: _unref(formatTime),
                  width: "120",
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "回款时间",
                  prop: "financialTime",
                  formatter: _unref(formatTime),
                  width: "120",
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "核销时间",
                  prop: "verifyTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "财务费用",
                  prop: "financialExpenses",
                  align: "right",
                  formatter: _unref(formatNumber),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "坏账",
                  prop: "badDebt",
                  align: "right",
                  formatter: _unref(formatNumber),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"])
              ]),
              _: 1
            }, 8, ["data", "infinite-scroll-disabled", "height"])), [
              [_unref(vElTableInfiniteScroll), orderLoad],
              [_directive_loading, ordIdentify.value]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      width: "30%",
      modelValue: isShowGetFlows.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((isShowGetFlows).value = $event)),
      title: "获取客户流水发票",
      center: "",
      onClose: _cache[19] || (_cache[19] = ($event: any) => (_unref(flowsParams).verify = false))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_30, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (getFlowsHandle()))
          }, {
            default: _withCtx(() => [
              _hoisted_31
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_el_checkbox, {
            modelValue: _unref(flowsParams).verify,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(flowsParams).verify) = $event)),
            label: "包含已勾销",
            border: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "计算发票本位币",
      modelValue: calculateFg.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((calculateFg).value = $event)),
      draggable: "",
      width: "580px"
    }, {
      default: _withCtx(() => [
        (calculateFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: calculateConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "计算流水本位币",
      modelValue: flowFg.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((flowFg).value = $event)),
      draggable: "",
      width: "580px"
    }, {
      default: _withCtx(() => [
        (flowFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: calculateConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "未匹配客户流水",
      modelValue: isShowUnmatch.value,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((isShowUnmatch).value = $event)),
      draggable: "",
      width: "900px",
      top: "8vh",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "info",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (resetUnmatchHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_32
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[26] || (_cache[26] = ($event: any) => (isShowUnmatch.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_33
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_collapse, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse_item, { title: "客户流水-搜索" }, {
              default: _withCtx(() => [
                _createVNode(_component_FlexibleForm, _mergeProps({
              title: true,
              initSearch: false,
              searchConfig: unMatchConfig.value,
            }, { onSearchFn: umatchSearchHandle }), null, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          ref_key: "unmatchEle",
          ref: unmatchEle,
          border: "",
          data: _unref(unmatchDate),
          "row-key": "id",
          onSelectionChange: _cache[22] || (_cache[22] = (rows) => _isRef(unCustomerRows) //@ts-ignore
 ? unCustomerRows.value = rows : unCustomerRows = rows),
          "max-height": "700px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "45",
              fixed: "",
              "reserve-selection": "",
              selectable: (row) => row.flowInvoiceId === null
            }, null, 8, ["selectable"]),
            _createVNode(_component_el_table_column, {
              label: "收付方名称",
              prop: "costTo",
              width: "125",
              "show-overflow-tooltip": "",
              fixed: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "订单ID",
              prop: "id",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "收款币别",
              prop: "receiptCurrency",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "收款金额",
              prop: "receiptAmount",
              width: "115",
              align: "right",
              formatter: _unref(formatNumber),
              sortable: ""
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "本位币",
              prop: "standardMoney",
              width: "115",
              align: "right",
              formatter: _unref(formatNumber),
              "show-overflow-tooltip": "",
              sortable: ""
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "回款日期",
              prop: "collectionAt",
              width: "115",
              sortable: ""
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.collectionAt ? _unref(dayjs)(row.collectionAt).format('YYYY-MM-DD HH:mm:ss') : ''), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "公司名称",
              prop: "costFrom",
              width: "230",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "账户简称",
              prop: "accountName",
              width: "135",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "币种",
              prop: "currency"
            }),
            _createVNode(_component_el_table_column, {
              label: "借方",
              prop: "costOut",
              align: "right",
              width: "100",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "贷方",
              prop: "costIn",
              width: "100",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "手续费",
              prop: "handlingFee",
              align: "right",
              width: "100",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "银行摘要",
              prop: "summary",
              width: "200",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "款项类型",
              prop: "paymentType",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              label: "备注",
              prop: "remarks",
              width: "130",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "匹配核销备注",
              prop: "matchRemarks",
              width: "150",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "团队",
              prop: "team",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "销售",
              prop: "saler",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "匹配状态",
              width: "115",
              prop: "matchStatus"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.matchStatus === 'Matched' ? '已匹配' : '未匹配'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "勾销状态",
              width: "115",
              prop: "verifyStatus"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.verifyStatus === null ? '未勾销' : row.verifyStatus === 'Verified' ? '已勾销' : '部分勾销'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              prop: "status"
            }),
            _createVNode(_component_el_table_column, {
              label: "导入批次",
              prop: "fileId",
              width: "150"
            }),
            _createVNode(_component_el_table_column, {
              label: "账户ID",
              prop: "accountNumber",
              "show-overflow-tooltip": ""
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(unmatchIdentify)]
        ]),
        _createVNode(_component_el_pagination, {
          background: "",
          small: "",
          total: _unref(unmatchTotal),
          currentPage: _unref(unmatchPage),
          "onUpdate:currentPage": _cache[23] || (_cache[23] = ($event: any) => (_isRef(unmatchPage) ? (unmatchPage).value = $event : null)),
          "page-size": _unref(unmatchSize),
          "onUpdate:page-size": _cache[24] || (_cache[24] = ($event: any) => (_isRef(unmatchSize) ? (unmatchSize).value = $event : null)),
          class: "mt-10",
          style: {"float":"none"},
          "page-sizes": [10, 30, 50, 200, 500],
          layout: "sizes, prev, pager, next, total, jumper",
          onCurrentChange: _unref(unmatchPgChnage),
          onSizeChange: _unref(unmatchSzChange)
        }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "导入",
      modelValue: isShowImport.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((isShowImport).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[29] || (_cache[29] = ($event: any) => (isShowImport.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_34
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[30] || (_cache[30] = ($event: any) => (submitImport()))
        }, {
          default: _withCtx(() => [
            _hoisted_35
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          type: "textarea",
          placeholder: "请输入订单号/发票号，支持分隔符：, ; . /换行符，中文逗号或空格",
          rows: 4,
          modelValue: importNoList.value,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((importNoList).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})